import { transactionService } from '../services'

export default (filters) => {
	return new Promise(resolve => {
		transactionService.getResumeAlerts(filters)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
